import React, { createContext } from 'react';

export type FileSearchContextType = {
  readonly keyword: string;
  readonly isSubmitted: boolean;
  handleChange: (data: string) => void;
  handleSubmit: () => void;
  onSubmitted: () => void;
};

// MEMO: 初期値は仮実装で埋める
export const FileSearchContext = createContext<FileSearchContextType>({
  keyword: '',
  isSubmitted: false,
  handleChange: () => {},
  handleSubmit: () => {},
  onSubmitted: () => {},
});

export const useFileSearchContext = (): FileSearchContextType => {
  const [keyword, setKeyword] = React.useState<string>('');
  const [isSubmitted, setIsSubmitted] = React.useState<boolean>(false);

  const handleChange = (data: string) => {
    setKeyword(data);
  };

  const handleSubmit = () => {
    setIsSubmitted(true);
  };

  const onSubmitted = () => {
    setIsSubmitted(false);
  };

  return {
    keyword,
    isSubmitted,
    handleChange,
    handleSubmit,
    onSubmitted,
  };
};
